declare var get_logrocket_configuration: any;

export async function init_logrocket(): Promise<void> {
    const config = get_logrocket_configuration();
    if (!config?.enabled) {
        return;
    }

    const { default: LogRocket } = await import('logrocket');

    LogRocket.init(config.environment, {
        network: {
            requestSanitizer: function(request: any) {
                for (const url of config.ignore_network_urls) {
                    if (request.url.toLowerCase().indexOf(url) !== -1) {
                        return null;
                    }
                }
                return request;
            }
        },
        release: config.release
    });

    if (config.user_data.user_id > 0) {
        LogRocket.identify(config.user_data.id!, config.user_data);
    }

    // Expose on window — utils.js and update_log_rocket_user.js reference LogRocket as a global.
    (window as any).LogRocket = LogRocket;
}
